import Authority from "../../Authority"
import { Appointment } from "./interfaces"

const INVALID_STATUS = ["ENDED", "CANCELLED"]

export const acceptRejectTransferValidation = (a: Appointment): boolean => {
  if(INVALID_STATUS.includes(a.transferStatus)){
    return false
  }  
  const hasItemsToAssign = a.items?.some(
    (item) =>
      item.transferItemRequestStatus === 'CREATED' &&
      item.companyIdPartnership.companyId === Authority.getAuthorizedCompanyId()
  )
  return (
    Authority.hasPermission('mobility_appointment_item_request_acept_reject') &&
    hasItemsToAssign
  )
} 